import React from 'react';

import { Row, Col } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import { ORDER_STATUS } from '../../../../../../utils/constants/order-status';
import { OrderSummary } from '../../../../../../api-client';
import { formatCurrency } from '../../../../../../utils/data-format-enchanters/currency-enchanter';
import { formatStandardDate } from '../../../../../../utils/data-format-enchanters/datetime-enchanter';

import './bv-orders-group-item.scss';

import BVOrderStatus from '../../../../../../common/components/BVOrderStatus/bv-order-status';

interface IBVOrdersGroupItem {
    order: OrderSummary;
    orderLoading: boolean;
    onClick: (order: OrderSummary) => void;
}

const BVOrdersGroupItem: React.FunctionComponent<IBVOrdersGroupItem> = ({ order, orderLoading, onClick }) => (
    <div className={`bv-orders-group-item-container bv-orders-group-item-${order.status?.toLowerCase()}`} onClick={() => onClick(order)}>
        <Row gutter={[12, 0]}>
            <Col span={6}>
                <div className={`${order.status === ORDER_STATUS.ERROR.code && 'status-error'}`}>
                    <BVOrderStatus
                        status={order.status}
                        title={order.status === ORDER_STATUS.ERROR.code
                            ? 'Some error occours in this order, check the order sap view for more details'
                            : ''
                        }
                    />

                    {orderLoading &&
                        <LoadingOutlined style={{ marginLeft: 10 }} />
                    }
                </div>
            </Col>
            <Col span={6}>
                <span className="customer-heading">{formatStandardDate(order.createdAt)}</span>
            </Col>
            <Col span={6}>
                <span className="customer-heading">{order.createdBy}</span>
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
                <span className="customer-heading">{formatCurrency(order.amount, order.currency)}</span>
            </Col>
        </Row>
    </div>
);

export default BVOrdersGroupItem;